import { render, staticRenderFns } from "./DetailsStatisticsFiltersPanel.vue?vue&type=template&id=47a3de09&"
import script from "./DetailsStatisticsFiltersPanel.vue?vue&type=script&lang=js&"
export * from "./DetailsStatisticsFiltersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports